import { defineMessages } from 'react-intl';
import type { IntlShape } from 'react-intl';

const messages = defineMessages({
  blockTitle: {
    id: 'Feature panel',
    defaultMessage: 'Feature panel',
  },
  contentFieldset: {
    id: 'Content',
    defaultMessage: 'Content',
  },
  layoutFieldset: {
    id: 'Layout',
    defaultMessage: 'Layout',
  },
  imageFieldset: {
    id: 'Image',
    defaultMessage: 'Image',
  },
  title: {
    id: 'Title',
    defaultMessage: 'Title',
  },
  text: {
    id: 'Text',
    defaultMessage: 'Text',
  },
  ctaLabel: {
    id: 'Button label',
    defaultMessage: 'Button label',
  },
  ctaLink: {
    id: 'Button link',
    defaultMessage: 'Button link',
  },
  image: {
    id: 'Image',
    defaultMessage: 'Image',
  },
  imageAlt: {
    id: 'Image alt text',
    defaultMessage: 'Image alt text',
  },
  imagePosition: {
    id: 'Image position',
    defaultMessage: 'Image position',
  },
  imagePositionLeft: {
    id: 'Left',
    defaultMessage: 'Left',
  },
  imagePositionRight: {
    id: 'Right',
    defaultMessage: 'Right',
  },
  colorVariant: {
    id: 'Color',
    defaultMessage: 'Color',
  },
  colorVariantTeal: {
    id: 'Teal',
    defaultMessage: 'Teal',
  },
  colorVariantNavy: {
    id: 'Navy',
    defaultMessage: 'Navy',
  },
  colorVariantBlue: {
    id: 'Blue',
    defaultMessage: 'Blue',
  },
  colorVariantGold: {
    id: 'Gold',
    defaultMessage: 'Gold',
  },
});

/**
 * Schema do bloco Feature panel.
 * Painel de destaque com imagem de um lado e bloco de cor sólida do outro
 * (título + texto + CTA). Ver docs/specs/blocks/feature-panel.md.
 */
const FeaturePanelSchema = ({ intl }: { intl: IntlShape }) => ({
  title: intl.formatMessage(messages.blockTitle),
  fieldsets: [
    {
      id: 'default',
      title: intl.formatMessage(messages.contentFieldset),
      // `text` legado saiu do form: o corpo agora são blocos aninhados
      // (ContainerEdit) — spec feature-panel.md §12.1.
      fields: ['title', 'ctaLabel', 'ctaLink'],
    },
    {
      id: 'layout',
      title: intl.formatMessage(messages.layoutFieldset),
      fields: ['imagePosition', 'colorVariant'],
    },
    {
      id: 'image',
      title: intl.formatMessage(messages.imageFieldset),
      fields: ['image', 'imageAlt'],
    },
  ],
  properties: {
    title: {
      title: intl.formatMessage(messages.title),
      type: 'string',
    },
    ctaLabel: {
      title: intl.formatMessage(messages.ctaLabel),
      type: 'string',
    },
    ctaLink: {
      title: intl.formatMessage(messages.ctaLink),
      widget: 'object_browser',
      mode: 'link',
      allowExternals: true,
    },
    imagePosition: {
      title: intl.formatMessage(messages.imagePosition),
      type: 'string',
      choices: [
        ['left', intl.formatMessage(messages.imagePositionLeft)],
        ['right', intl.formatMessage(messages.imagePositionRight)],
      ],
      default: 'left',
    },
    colorVariant: {
      title: intl.formatMessage(messages.colorVariant),
      type: 'string',
      choices: [
        ['teal', intl.formatMessage(messages.colorVariantTeal)],
        ['navy', intl.formatMessage(messages.colorVariantNavy)],
        ['blue', intl.formatMessage(messages.colorVariantBlue)],
        ['gold', intl.formatMessage(messages.colorVariantGold)],
      ],
      default: 'teal',
    },
    image: {
      title: intl.formatMessage(messages.image),
      widget: 'image',
    },
    imageAlt: {
      title: intl.formatMessage(messages.imageAlt),
      type: 'string',
    },
  },
  required: [],
});

export default FeaturePanelSchema;
